module.exports = __webpack_public_path__ + "static/media/phone-icon-form.8f9135ae.svg";